/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ArticleInTextTeaser/theme';

export const ArticleInTextTeaserTheme = theme;
